import React from 'react';
import { DisplayStatus } from '../../types/billing';
import { statusTone } from '../../utils/billingMoney';
export function DocStatusBadge({
  status
}: {
  status: DisplayStatus | 'Posted' | 'Reversed' | 'Issued' | 'Active' | 'Inactive' | 'Paused' | 'Ended' | 'Completed';
}) {
  const extra: Record<string, string> = {
    Inactive: 'bg-slate-100 text-slate-500 ring-slate-200',
    Completed: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
    Posted: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
    Reversed: 'bg-red-50 text-red-700 ring-red-200',
    Issued: 'bg-sky-50 text-sky-800 ring-sky-200',
    Active: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
    Paused: 'bg-amber-50 text-amber-800 ring-amber-200',
    Ended: 'bg-slate-100 text-slate-500 ring-slate-200'
  };
  const tone = (statusTone as Record<string, string>)[status] ?? extra[status] ?? 'bg-slate-100 text-slate-700 ring-slate-200';
  return <span className={`inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${tone}`} data-id="element-3505" data-mp="292m9kk8q4fvx">{status}</span>;
}